import { Group } from '@/components/_common';
import ActionIcon from '@/components/_common/ActionIcon';
import { WorkOrderComplementStatus } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { Row, Col, Typography, Button, Modal } from 'antd';
import { FaInfoCircle } from 'react-icons/fa';
import { useWorkorderDetailContext } from '../../../WorkorderDetailProvider';

interface Props {
  hasBenefits: boolean;
  onSubmit: VoidFunction;
  isSubmiting: boolean;
}

export default function ComplementPolicyBenefitsHeader(props: Props) {
  const {
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const isClosedOrCanceled =
    complement?.status === WorkOrderComplementStatus.Closed ||
    complement?.status === WorkOrderComplementStatus.Cancelled;

  const benefitInfo = () =>
    Modal.confirm({
      title: 'Benefícios do segurado',
      content:
        'Configure e insira os benefícios da apólice do segurado na ordem de serviço. Os benefícios são inseridos como itens tercerizados e sem aplicação de valores',
      okButtonProps: { style: { display: 'none' } },
      cancelText: 'Fechar',
    });

  return (
    <Row style={{ marginTop: 24, marginBottom: 24 }}>
      <Col flex={1}>
        <Group gap={10}>
          <Typography.Title level={3} style={{ margin: 0 }}>
            Benefícios do segurado
          </Typography.Title>

          <ActionIcon onClick={benefitInfo}>
            <FaInfoCircle size={20} />
          </ActionIcon>
        </Group>
      </Col>

      <Col>
        <Button
          onClick={props.onSubmit}
          loading={props.isSubmiting}
          disabled={!props.hasBenefits || isClosedOrCanceled}
        >
          Gerar itens dos benefícios
        </Button>
      </Col>
    </Row>
  );
}
